import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarIcon, NotificationIcon, ProfileIcon, SachbezugIcon } from '../../../icons';
import Util from '../../../../misc/util';
import { useCompanyContactData } from '../../../../queries/company';
import { useStore } from '../../../../hooks/useStore';

export type AppMockupProps = {
  logo?: string;
};

export const AppMockup: FC<AppMockupProps> = ({ logo }) => {
  const { t } = useTranslation();

  const { companyStore } = useStore();
  const companyId = companyStore.company?.id ?? 'MISSING_ID';

  const { data } = useCompanyContactData(companyId);

  return (
    <div className="w-[400px] bg-primary-main text-white rounded-2xl m-auto p-4">
      <div className="mb-4 flex justify-between items-center">
        <div className="flex items-center">
          {logo ? (
            <div className="h-8 max-w-[152px] rounded-2xl bg-white py-1 px-3 mr-3">
              <img src={logo} alt="" className="h-full w-auto max-w-full object-contain" />
            </div>
          ) : (
            <div className="font-bold">
              {t('app:hello')}{' '}
              {!data?.first_name || data.first_name === '' ? 'Isabella' : data.first_name}
            </div>
          )}
        </div>
        <div className="flex gap-x-3">
          <NotificationIcon />
          <ProfileIcon />
        </div>
      </div>
      <div className="flex flex-col">
        <div className="flex justify-between items-center mx-4">
          <div className="text-xl font-bold">{t('app:yourBudget')}</div>
          <div className="text-sm">{t('app:planner')} &gt;</div>
        </div>
        <div className="mt-4 rounded-2xl bg-white px-8 py-6 text-primary-main">
          <div className="flex flex-col justify-between">
            <div className="text-sm">{Util.getCurrentMonthString()}</div>
            <div className="flex justify-between items-center">
              <div className="text-2xl font-bold">{Util.formatCurrency(20000)}</div>
              <CalendarIcon className="h-5 w-5" />
            </div>
            <div className="relative w-full">
              <div className="mt-4 flex h-8 items-center justify-between overflow-hidden rounded-full bg-mint-main">
                <div className="h-full rounded-r-full bg-heaven-600 w-3/4"></div>
              </div>
              <span className="absolute left-0 top-1/2 px-2 text-xs font-bold leading-4 text-white">
                {Util.formatCurrency(15000)}
              </span>
              <span className="absolute right-0 top-1/2 px-2 text-xs font-bold leading-4 text-success-dark">
                {Util.formatCurrency(5000)}
              </span>
            </div>
            <div className="flex flex-row justify-center gap-x-8 pt-4 text-sm font-normal text-night">
              <div className="flex items-center">
                <div className="mr-2 h-4 w-4 rounded-full bg-heaven-600"></div>
                <div>{t('app:used')}</div>
              </div>
              <div className="flex items-center">
                <div className="mr-2 h-4 w-4 rounded-full bg-mint-main"></div>
                <div>{t('app:remaining')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="ml-4 mt-8 text-xl font-bold text-white">{t('app:yourBenefits')}</div>
        <div className="flex mt-4 rounded-2xl bg-white p-4 text-primary-main">
          <div className="h-10 w-10 rounded-xl bg-heaven-600 text-white p-auto">
            <SachbezugIcon className="" height="40px" width="40px" />
          </div>
          <div className="ml-4 w-full flex justify-between">
            <div className="flex flex-col w-full">
              <div className="flex justify-between font-bold">
                <div>{t('benefits:sachbezug')}</div>
                <div className="text-heaven-600">{Util.formatCurrency(5000)}</div>
              </div>
              <div className="col-span-2 flex justify-between text-sm text-grey-600">
                {t('app:fixedAmount')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
